const FAILED_STATES = new Set(["failed", "partial", "bounced", "suppressed"]);
const QUEUED_STATES = new Set(["pending", "queued", "deferred", "sending"]);
const REACHED_STATES = new Set(["sent", "accepted", "delivered"]);

export const getDeliverySummary = (messages = [], scheduledEmails = []) => {
  const deliveries = [...messages, ...scheduledEmails];
  return {
    reached: deliveries.filter((item) => REACHED_STATES.has(item.status)).length,
    queued: deliveries.filter((item) => QUEUED_STATES.has(item.status)).length,
    failed: deliveries.filter((item) => FAILED_STATES.has(item.status)).length,
  };
};

export const describeAudience = ({ type, program_id, household_id }, programs = [], households = []) => {
  if (type === "individual") {
    const household = households.find((item) => item.household_id === household_id);
    return household ? `${household.name || "Selected household"} contacts` : "Choose one household";
  }

  const program = programs.find((item) => item.program_id === program_id);
  return program ? `${program.name} registrants` : "Choose a program audience";
};

export const getRecoverableDeliveries = (messages = [], scheduledEmails = []) => [
  ...scheduledEmails.filter((email) => FAILED_STATES.has(email.status)),
  ...messages.filter((message) => FAILED_STATES.has(message.status)),
];

export const getCommunicationActions = (messages = [], scheduledEmails = []) => {
  const failed = getRecoverableDeliveries(messages, scheduledEmails);
  const deferred = [...messages, ...scheduledEmails].filter((item) => item.status === "deferred");
  const pending = scheduledEmails.filter((item) => item.status === "pending");
  const actions = [];
  if (failed.length) actions.push({ id: "failed", count: failed.length, label: "Deliveries need review", tone: "critical" });
  if (deferred.length) actions.push({ id: "deferred", count: deferred.length, label: "Deliveries are retrying", tone: "warning" });
  if (pending.length) actions.push({ id: "scheduled", count: pending.length, label: "Announcements are scheduled", tone: "neutral" });
  return actions;
};

export const describeMessageStatus = (status) => ({
  delivered: "Delivered",
  accepted: "Provider accepted",
  sent: "Sent (legacy)",
  queued: "Queued",
  pending: "Scheduled",
  deferred: "Retrying",
  partial: "Partially delivered",
  failed: "Needs review",
  bounced: "Bounced",
  suppressed: "Suppressed",
}[status] || "Processing");
